import * as React from 'react';
import RenderDesktop from './RenderDesktop';
import RenderMobile from './RenderMobile';

const RenderBreakpoint = ({ mobile, desktop, children }) => (
  <React.Fragment>
    {mobile && (
      <RenderMobile>
        {typeof children === 'function'
          ? children({ isMobile: true })
          : children}
      </RenderMobile>
    )}
    
    {desktop && (
      <RenderDesktop>
        {typeof children === 'function'
          ? children({ isDesktop: true })
          : children}
      </RenderDesktop>
    )}
  </React.Fragment>
);

export default RenderBreakpoint;
